module.exports = __webpack_public_path__ + "img/ruan1.8f3a377e.jpg";